import './client.css'
import '@wix/design-system/styles.global.css'
import '@wix/wildcat-ui/global.css'

import { WixDesignSystemProvider } from '@wix/design-system'
import { ErrorMonitorBoundary, ErrorMonitorProvider } from '@wix/error-monitor/react'
import React, { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import { App } from './components/App/App'
import { errorMonitor } from './errorMonitor'

const root = createRoot(document.getElementById('root')!)

root.render(
  <ErrorMonitorBoundary
    fallback={
      <div>
        <div>Something went wrong. The error is reported and we will fix it soon.</div>
        <div>In the meantime, please refresh the page.</div>
      </div>
    }
    errorMonitor={errorMonitor}
  >
    <Suspense fallback={null}>
      <ErrorMonitorProvider errorMonitor={errorMonitor}>
        <WixDesignSystemProvider features={{ newColorsBranding: true }}>
          <BrowserRouter>
            <Routes>
              <Route path="*" element={<App />} />
            </Routes>
          </BrowserRouter>
        </WixDesignSystemProvider>
      </ErrorMonitorProvider>
    </Suspense>
  </ErrorMonitorBoundary>,
)
